<template>
  <!-- Table Container Card -->
  <b-card no-body>
    <div class="m-2">
      <!-- Table Top -->
      <b-row>
        <!-- Search -->
        <b-col
          cols="6"
          md="9"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              v-model="searchQuery"
              class="d-inline-block mr-1"
              :placeholder="$t('globalActions.findCode')"
            />
          </div>
          <div class="d-flex align-items-center justify-content-end">
              <b-button
                variant="primary"
                @click="SearchData(searchQuery)"
              > Cari
          </b-button>
          </div>
        </b-col>

        <!-- Add -->
        <b-col
          cols="12"
          md="3"
          class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
        >
          <b-button
            variant="primary"
            :to="{ name: 'apps-transactions-cash-advance-add'}"
          >
            <feather-icon icon="PlusIcon" /> {{ $t('apps.transactionsCashAdvance.actions.create') }}
          </b-button>
        </b-col>
      </b-row>
    </div>

    <b-table
       id="refListTable"
      ref="refListTable"
      no-provider-paging
      no-provider-filtering
      :filter-ignored-fields="columnToBeFilter"
      :fields="tableColumns"
      :items="itemLists"
      responsive
      primary-key="id"
      show-empty
      :busy="isBusy"
      :empty-text="$t('globalSingular.noMatching')"
      :sort-desc.sync="isSortDirDesc"
      class="position-relative"
    >

      <template #table-busy>
        <div class="text-center text-primary my-2 d-flex flex-column justify-content-center">
          <div class="text mb-1">
            <b-spinner class="align-middle"/>
          </div>
          <strong>{{ $t('globalActions.fetchingDataAPI') }}</strong>
        </div>
      </template>

      <template #cell(code)="data">
        <b-link
          :to="{ name: 'apps-transactions-cash-advance-detail', params: { id: data.item.id }}"
          class="font-weight-bold"
        >
          {{ data.item.code }}
        </b-link>
      </template>

      <template #cell(date)="data">
        <span class="font-weight-bold d-block text-nowrap">
          {{ data.item.date }}
        </span>
      </template>

      <template #cell(purpose_date)="data">
        <span class="font-weight-bold d-block text-nowrap">
          {{ data.item.purpose_date }}
        </span>
      </template>

      <template #cell(employee)="data">
        <span class="font-weight-bold d-block text-nowrap">
          {{ data.item.employee.code }} - {{ data.item.employee.pic_name }}
        </span>
      </template>

      <template #cell(user_create)="data">
        <span class="font-weight-bold d-block text-nowrap">
          {{ data.item.userCreate.user_name }}
        </span>
      </template>

      <template #cell(request_amount)="data">
        <span class="font-weight-bold d-block text-nowrap">
          {{ data.value }}
        </span>
      </template>

      <template #cell(audit)="{ item }">
        <span class="font-weight-bolder d-block text-nowrap">
        {{ item.updated_process }}  By {{ item.userCreate.user_name }}
        </span>
        <small class="font-italic">{{ new Date(item.updated_at).toDateString() }}</small>
      </template>

    </b-table>

    <div class="mx-2 mb-2">
      <b-row>

        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >

          <b-pagination
            v-model="currentPage"
            :total-rows="totalList"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
            aria-controls="refInvoiceListTable"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>

  </b-card>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BTable,
  BLink,
  BPagination,
  BSpinner,
  BButton
} from 'bootstrap-vue'

import {formatCurrency} from '@/utils/formatter'
import useLocalization from '@/comp-functions/utils/useLocalization'
import useListTablePage from '@/comp-functions/useListTablePage'



export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BLink,
    BPagination,
    BSpinner,
    BButton
  },
  setup () {
    // Table Handlers
    const { $t } = useLocalization()
    const tableColumns = [
      { key: 'code', label: 'Code', sortable: true },
      { key: 'cashAdvanceRequest.code', label: 'No. Request', sortable: true },
      { key: 'date', label: 'Date' },
      { key: 'getOffice.brand', label: $t('globalSingular.branch') },
      { key: 'employee', label: 'Employee' },
      {
        key: 'amount',
        label: 'Cash Advance Amount',
        formatter: value => {
          return formatCurrency(value)
        }
      },
      {
        key: 'realisation_amount',
        label: 'Realisation Amount',
        formatter: value => {
          return formatCurrency(value)
        }
      },
      {
        key: 'refund_amount',
        label: 'Refund Amount',
        formatter: value => {
          return formatCurrency(value)
        }
      },
      {
        key: 'out',
        label: 'Outstanding',
        formatter: value => {
          return formatCurrency(value)
        }
      },
      { key: 'user_create', label: 'User Create' },
      { key: 'audit', label: $t('globalSingular.audit') }
    ]

    // Table Handlers
    const columnToBeFilter = [
      'code',
      'date',
      'employee',
      'userCreate'
    ]

    const {
      isBusy,
      itemLists,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      statusFilter,
      fetchLists,
      loadPage,
      changePerPage
    } = useListTablePage({ url: 'transaction/cash-advance?', urlcount: 'transaction/count-cash-advance' })

    const SearchData = datasearch => {
        loadPage(`transaction/cash-advance?search=${datasearch.toUpperCase()}`)
    }
    return {
      tableColumns,
      columnToBeFilter,
      isBusy,
      itemLists,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      statusFilter,
      fetchLists,
      loadPage,
      changePerPage,
      SearchData
    }
  }
}
</script>
